import { sumAmounts } from '../money';

/** The committee's reports: shared by its phone app and the desk (doc 45). */

/** Total owed by everyone on the list (a display sum of arqam's amounts). */
export const totalDue = (rows: { amountDue: string }[]) =>
  sumAmounts(rows.map((r) => r.amountDue));

/** Years that have billed months, newest first (for the annual report). */
export function reportYears(months: { month: string }[]): number[] {
  return [...new Set(months.map((m) => Number(m.month.slice(0, 4))))].sort(
    (a, b) => b - a,
  );
}

export type ArrearsFilter = 'all' | 'public' | 'unreachable';

type ArrearRow = {
  publiclyListed: boolean;
  phoneStatus: string | null;
  notifyChannel: string;
};

export function filterArrears<T extends ArrearRow>(
  rows: T[],
  filter: ArrearsFilter,
): T[] {
  if (filter === 'public') return rows.filter((r) => r.publiclyListed);
  if (filter === 'unreachable') {
    return rows.filter(
      (r) => r.phoneStatus !== 'OK' || r.notifyChannel === 'NONE',
    );
  }
  return rows;
}
